import { render } from "./EditAssignation.vue?vue&type=template&id=4f723734&scoped=true&ts=true"
import script from "./EditAssignation.vue?vue&type=script&lang=ts"
export * from "./EditAssignation.vue?vue&type=script&lang=ts"

import "./EditAssignation.vue?vue&type=style&index=0&id=4f723734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f723734"]])

export default __exports__